import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'price-calculator',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'registration',
    loadChildren: () => import('./pages/registration/registration.module').then( m => m.RegistrationPageModule)
  },
  {
    path: 'connections',
    loadChildren: () => import('./pages/connections/connections.module').then( m => m.ConnectionsPageModule)
  },
  {
    path: 'hardware',
    loadChildren: () => import('./pages/hardware/hardware.module').then( m => m.HardwarePageModule)
  },
  {
    path: 'connections/:uuid',
    loadChildren: () => import('./pages/connections-details/connections-details.module').then( m => m.ConnectionsDetailsPageModule)
  },
  {
    path: 'hardware/:uuid',
    loadChildren: () => import('./pages/hardware-details/hardware-details.module').then( m => m.HardwareDetailsPageModule)
  },
  {
    path: 'active-accounts',
    loadChildren: () => import('./pages/active-accounts/active-accounts.module').then( m => m.ActiveAccountsPageModule)
  },
  {
    path: 'account/:accountNum',
    loadChildren: () => import('./pages/account-details/account-details.module').then( m => m.AccountDetailsPageModule)
  },
  {
    path: 'account/:accountNum/service-roi',
    loadChildren: () => import('./pages/service-roi/service-roi.module').then( m => m.ServiceRoiPageModule)
  },
  {
    path: 'account/:accountNum/sales-roi',
    loadChildren: () => import('./pages/sales-roi/sales-roi.module').then( m => m.SalesRoiPageModule)
  },
  {
    path: 'account/:accountNum/sales-roi/:dealMonth',
    loadChildren: () => import('./pages/sales-matches/sales-matches.module').then( m => m.SalesMatchesPageModule)
  },
  {
    path: 'account/:accountNum/service-roi/:closeMonth',
    loadChildren: () => import('./pages/service-matches/service-matches.module').then( m => m.ServiceMatchesPageModule)
  },
  {
    path: 'account/:accountNum/service-match-detail/:campaignKey/:roKey',
    loadChildren: () => import('./pages/service-match-details/service-match-details.module').then( m => m.ServiceMatchDetailsPageModule)
  },
  {
    path: 'account/:accountNum/sales-match-details/:dealNum',
    loadChildren: () => import('./pages/sales-match-details/sales-match-details.module').then( m => m.SalesMatchDetailsPageModule)
  },
  {
    path: 'account/:accountNum/customer-details/:customerNum',
    loadChildren: () => import('./pages/customer-details/customer-details.module').then( m => m.CustomerDetailsPageModule)
  },
  {
    path: 'account/:accountNum/vin-details/:vin',
    loadChildren: () => import('./pages/vin-details/vin-details.module').then( m => m.VinDetailsPageModule)
  },
  {
    path: 'account/:accountNum/target-list',
    loadChildren: () => import('./pages/target-list/target-list.module').then( m => m.TargetListPageModule)
  },
  {
    path: 'price-calculator',
    loadChildren: () => import('./pages/price-calculator/price-calculator.module').then( m => m.PriceCalculatorPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
